import { render, staticRenderFns } from "./imgG.vue?vue&type=template&id=773fa6e0&scoped=true"
var script = {}
import style0 from "./imgG.vue?vue&type=style&index=0&id=773fa6e0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773fa6e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('773fa6e0')) {
      api.createRecord('773fa6e0', component.options)
    } else {
      api.reload('773fa6e0', component.options)
    }
    module.hot.accept("./imgG.vue?vue&type=template&id=773fa6e0&scoped=true", function () {
      api.rerender('773fa6e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/employeeCardPlaceholders/imgG.vue"
export default component.exports